"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _mobx = require("mobx");
var _store = require("@tajawal/web-core-sdk-v2/lib/utils/store.utils");
var _loyaltyGet = _interopRequireDefault(require("./loyalty-get.store"));
var _loyaltySave = _interopRequireDefault(require("./loyalty-save.store"));
var _pointsExchangeCheckout = _interopRequireDefault(require("./points-exchange-checkout.store"));
var _pointsExchangeProductSearch = _interopRequireDefault(require("./points-exchange-product-search.store"));
var _pointsExchangeInitRedeem = _interopRequireDefault(require("./points-exchange-init-redeem.store"));
var _pointsExchangeWalletBalance = _interopRequireDefault(require("./points-exchange-wallet-balance.store"));
var _pointsExchangeCustomAmount = _interopRequireDefault(require("./points-exchange-custom-amount.store"));
var _class;
/**
 * Promo page store
 */
let PointsExchangePageStore = (_class = /*#__PURE__*/function () {
  /**
   * constructor
   * @param {Object} initialState
   */
  function PointsExchangePageStore(initialState = {}, $env) {
    (0, _classCallCheck2.default)(this, PointsExchangePageStore);
    this.getLoyalty = void 0;
    this.saveLoyalty = void 0;
    this.initRedeem = void 0;
    this.checkoutStore = void 0;
    this.productSearch = void 0;
    this.customAmount = void 0;
    this.walletBalanceStore = void 0;
    this.loyaltyProvider = void 0;
    this.updateInitialState(initialState);
    this.getLoyalty = new _loyaltyGet.default(initialState.getLoyalty);
    this.saveLoyalty = new _loyaltySave.default(initialState.saveLoyalty);
    this.initRedeem = new _pointsExchangeInitRedeem.default(initialState.initRedeem);
    this.checkoutStore = new _pointsExchangeCheckout.default(initialState.checkoutSore);
    this.productSearch = new _pointsExchangeProductSearch.default(initialState.productSearch);
    this.customAmount = new _pointsExchangeCustomAmount.default(initialState.customAmount);
    this.walletBalanceStore = new _pointsExchangeWalletBalance.default(initialState.walletBalanceStore);
  }
  (0, _createClass2.default)(PointsExchangePageStore, [{
    key: "loyaltyAccounts",
    get: function () {
      var _this$getLoyalty$data;
      const accounts = (_this$getLoyalty$data = this.getLoyalty.data) === null || _this$getLoyalty$data === void 0 ? void 0 : _this$getLoyalty$data[this.loyaltyProvider];
      return accounts;
    }

    /**
     * update initial state
     * @param {Object} initialState
     */
  }, {
    key: "updateInitialState",
    value: function updateInitialState(initialState) {
      (0, _store.mapInitialStateToStoreState)(this, initialState);
    }
  }, {
    key: "setLoyaltyProvider",
    value: function setLoyaltyProvider(provider) {
      this.loyaltyProvider = provider;
    }
  }, {
    key: "getLoyaltyAccounts",
    value: function getLoyaltyAccounts(provider, successHandler) {
      this.getLoyalty.getLoyalties({
        provider,
        successHandler
      });
    }
  }, {
    key: "addLoyaltyAccount",
    value: function addLoyaltyAccount(accountInfo, successHandler, errorHandler) {
      this.saveLoyalty.saveLoyalty({
        data: accountInfo,
        successHandler,
        errorHandler
      });
    }
  }]);
  return PointsExchangePageStore;
}(), ((0, _applyDecoratedDescriptor2.default)(_class.prototype, "loyaltyAccounts", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "loyaltyAccounts"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateInitialState", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setLoyaltyProvider", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "setLoyaltyProvider"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "getLoyaltyAccounts", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "getLoyaltyAccounts"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "addLoyaltyAccount", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "addLoyaltyAccount"), _class.prototype)), _class);
exports.default = PointsExchangePageStore;